export default "__VITE_PUBLIC_ASSET__69a7cf1b__"